import { createContext, useContext } from "react";

interface FormErrorsContextType {
  validationErrorsWithoutControl: string[][];
}

export const FormErrorsContext = createContext<FormErrorsContextType>({
  validationErrorsWithoutControl: [],
});

export const useFormErrors = () => {
  const context = useContext(FormErrorsContext);
  if (!context) {
    throw new Error(
      "useFormErrors must be used within a FormErrorsContext provider",
    );
  }
  return context;
};
